import { ActionType } from './actions';
import { initialState, IState } from './state';
import { deleteObjectItem } from '../../../utils/generalUtils';
import { ConsentFormFieldType } from 'modules/models/client';
import { SearchModel } from 'modules/models';

export const reducer = (state: IState = initialState, { type, payload }: { type: ActionType; payload?: any }): IState => {
  switch (type) {
    case ActionType.SET_LOADING:
      return {
        toastList: [],
        ...state,
        loadingMap: {
          ...state.loadingMap,
          [payload.key]: { isLoading: payload.isLoading, hasError: !!payload.hasError, error: payload.error, traceId: payload.traceId },
        },
      };
    case ActionType.CLEAR_LOADING:
      return {
        ...state,
        loadingMap: {
          ...state.loadingMap,
          [payload.key]: undefined,
        },
      };
    case ActionType.CLEAR_LOADING_MAP:
      return {
        ...state,
        loadingMap: {},
      };
    case ActionType.SET_RELATION_UI_ID:
      if (payload.isSecond) {
        return {
          ...state,
          uiRelationMap2: !payload.value ? deleteObjectItem(state.uiRelationMap2, payload.key) : { ...state.uiRelationMap2, [payload.key]: payload.value },
        };
      } else {
        return {
          ...state,
          uiRelationMap: !payload.value ? deleteObjectItem(state.uiRelationMap, payload.key) : { ...state.uiRelationMap, [payload.key]: payload.value },
        };
      }
    case ActionType.CLEAR_RELATION_MAP:
      return {
        ...state,
        uiRelationMap: {},
      };
    case ActionType.ADD_TOAST_SUCCESS:
      return { ...state, toastList: [...state.toastList, payload] };
    case ActionType.REMOVE_TOAST:
      return { ...state, toastList: state.toastList.filter(item => item._id !== payload._id) };
    case ActionType.SET_MODAL_MAP:
      return { ...state, modalMap: payload.list.reduce((total, item) => ({ ...total, [item.id]: item }), {}), modalCount: payload.count };
    case ActionType.SET_HIDE_SCROLL:
      return { ...state, hideScroll: payload.hide };
    case ActionType.FETCH_COUNTRY_LIST_SUCCESS:
      return { ...state, countryList: payload.list };
    case ActionType.FETCH_TIME_ZONE_LIST_SUCCESS:
      return { ...state, timeZoneList: payload.list };
    case ActionType.FETCH_SEARCH_SUCCESS:
      return { ...state, searchResults: payload.list };
    case ActionType.FETCH_SEARCH_NEW_SUCCESS:
      return {
        ...state,
        ...(payload.searchType === SearchModel.SearchType.NotSet
          ? {
              searchResults: {
                ...state.searchResults,
                items: payload.list?.items,
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
              },
              searchResultsForWorkers: {
                items: payload.list?.items?.filter(sr => sr.entityType === SearchModel.SearchType.Worker),
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).filter(sr => sr.entityType === SearchModel.SearchType.Worker)?.length < 10,
              },
              searchResultsForUsers: {
                items: payload.list?.items?.filter(sr => sr.entityType === SearchModel.SearchType.Users),
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).filter(sr => sr.entityType === SearchModel.SearchType.Users)?.length < 10,
              },
              searchResultsForClients: {
                items: payload.list?.items?.filter(sr => sr.entityType === SearchModel.SearchType.Company),
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).filter(sr => sr.entityType === SearchModel.SearchType.Company)?.length < 10,
              },
              searchResultsForProjects: {
                items: payload.list?.items?.filter(sr => sr.entityType === SearchModel.SearchType.Project),
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).filter(sr => sr.entityType === SearchModel.SearchType.Project)?.length < 10,
              },
              searchResultsForInvoices: {
                items: payload.list?.items?.filter(sr => sr.entityType === SearchModel.SearchType.Invoice),
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).filter(sr => sr.entityType === SearchModel.SearchType.Invoice)?.length < 10,
              },
            }
          : {}),
        ...(payload.searchType === SearchModel.SearchType.Worker
          ? {
              searchResultsForWorkers: {
                items: [...(state.searchResultsForWorkers?.items || []), ...(payload.list?.items || [])],
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).length < 10,
              },
            }
          : {}),
        ...(payload.searchType === SearchModel.SearchType.Users
          ? {
              searchResultsForUsers: {
                items: [...(state.searchResultsForUsers?.items || []), ...(payload.list?.items || [])],
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).length < 10,
              },
            }
          : {}),
        ...(payload.searchType === SearchModel.SearchType.Company
          ? {
              searchResultsForClients: {
                items: [...(state.searchResultsForClients?.items || []), ...(payload.list?.items || [])],
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).length < 10,
              },
            }
          : {}),
        ...(payload.searchType === SearchModel.SearchType.Project
          ? {
              searchResultsForProjects: {
                items: [...(state.searchResultsForProjects?.items || []), ...(payload.list?.items || [])],
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).length < 10,
              },
            }
          : {}),
        ...(payload.searchType === SearchModel.SearchType.Invoice
          ? {
              searchResultsForInvoices: {
                items: [...(state.searchResultsForInvoices?.items || []), ...(payload.list?.items || [])],
                pageNumber: payload.list?.pageNumber,
                pageSize: payload.list?.pageSize,
                totalResults: payload.list?.totalResults,
                endReached: (payload.list?.items || []).length < 10,
              },
            }
          : {}),
      };
    case ActionType.FETCH_SEARCH_MORE_SUCCESS:
    case ActionType.FETCH_SEARCH_NEW_MORE_SUCCESS:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          items: [...(state.searchResults?.items ?? []), ...payload.list.items],
          pageNumber: payload.list.pageNumber,
          pageSize: payload.list.pageSize,
          totalResults: payload.list.totalResults,
        },
      };
    case ActionType.CLEAR_SEARCH:
      return {
        ...state,
        searchResults: undefined,
        searchResultsForWorkers: undefined,
        searchResultsForUsers: undefined,
        searchResultsForClients: undefined,
        searchResultsForProjects: undefined,
        searchResultsForInvoices: undefined,
      };
    case ActionType.FETCH_FEATURE_FLAG_SUCCESS:
      return {
        ...state,
        featuresMap: (payload.list || []).reduce((obj, item) => {
          obj[item.key] = item.enabled;
          return obj;
        }, {}),
      };
    case ActionType.FETCH_CONSENT_FORM_FIELDS_SUCCESS:
      if (payload.consentFormFieldType === ConsentFormFieldType.Standard) {
        return {
          ...state,
          standardConsentFormFields: payload.data,
        };
      }
      return {
        ...state,
        consentFormFields: payload.data,
      };
    case ActionType.FETCH_REGULAR_EXPRESSIONS_SUCCESS:
      return {
        ...state,
        regularExpressions: payload,
      };
    case ActionType.FETCH_BILLING_ENGINE_SETTINGS_SUCCESS:
      return {
        ...state,
        billingEngineSettings: payload,
      };
    default:
      return state;
  }
};
